import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import GroupHeader from "@/components/GroupHeader";
import GroupFooter from "@/components/GroupFooter";
import SEO from "@/components/SEO";
import { api } from "@/lib/api";
import { errorText } from "@/lib/circle";

export default function CircleUnsubscribe() {
    const [params] = useSearchParams();
    const token = params.get("t") || "";
    const [state, setState] = useState("idle");
    const [error, setError] = useState("");
    const confirm = async () => {
        setState("busy");
        try { await api.post("/investor-circle/unsubscribe", { token }); setState("done"); } catch (err) { setError(errorText(err)); setState("idle"); }
    };
    return (
        <div className="bg-cream min-h-screen flex flex-col" data-testid="ic-unsubscribe-page">
            <SEO path="/investor-circle/unsubscribe" title="Unsubscribe" description="Unsubscribe from The Investor Circle emails." noindex />
            <GroupHeader alwaysDark />
            <main className="flex-1 max-w-xl mx-auto px-6 pt-40 pb-24">
                <p className="mono-label text-moss">The Investor Circle</p>
                {state === "done" ? (
                    <>
                        <h1 className="font-serif text-4xl md:text-5xl text-forest mt-6" data-testid="ic-unsub-done">You've been unsubscribed.</h1>
                        <p className="mt-5 text-muted_text leading-relaxed">You won't receive further emails from The Investor Circle. If you'd also like us to delete your details entirely, write to hello@verde2050.com.</p>
                    </>
                ) : (
                    <>
                        <h1 className="font-serif text-4xl md:text-5xl text-forest mt-6">Unsubscribe from our emails?</h1>
                        <p className="mt-5 text-muted_text leading-relaxed">Confirm below and we'll stop sending you Investor Circle emails.</p>
                        {!token && <p className="mt-5 text-sm text-[#9A3B2E]" role="alert">This link is incomplete. Please use the unsubscribe link from your email.</p>}
                        {error && <p className="mt-5 text-sm text-[#9A3B2E]" role="alert" data-testid="ic-unsub-error">{error}</p>}
                        <button type="button" onClick={confirm} disabled={!token || state === "busy"} data-testid="ic-unsub-confirm"
                                className="mt-8 inline-flex items-center gap-2 rounded-full bg-forest text-cream px-8 py-4 text-sm font-medium disabled:opacity-50">
                            {state === "busy" && <Loader2 className="h-4 w-4 animate-spin" />} Unsubscribe
                        </button>
                    </>
                )}
                <p className="mt-10"><Link to="/" className="text-sm underline text-forest">Back to Verde 2050</Link></p>
            </main>
            <GroupFooter />
        </div>
    );
}
